export default {
   name: 'ConfirmModal',
   props: ['triageElem'],
   methods: {
      modalCancel() {
         this.triageElem = null
      }
   }
}
